import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ToggleProps {
  disabled?: boolean;
  isLoading?: boolean;
  children?: ReactNode;
  htmlFor?: string;
}

export const Toggle = styled.label<ToggleProps>`
  cursor: pointer;
  display: inline-flex;
  margin-bottom: 0;
  position: relative;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: initial;
    `}

  ${({ isLoading }) =>
    isLoading &&
    css`
      ${Indicator} {
        opacity: 0.5;
      }
    `}
`;

interface InputProps {
  type?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: any;
  name?: string;
  id?: string;
  value?: any;
  defaultChecked?: boolean;
}

export const Input = styled.input<InputProps>`
  cursor: not-allowed;
  opacity: 0;
  position: absolute;
  z-index: -1;
`;

interface IndicatorProps {
  children?: ReactNode;
}

export const Indicator = styled.span<IndicatorProps>`
  background-color: #fff;
  border: 2px solid #666;
  border-radius: 15px;
  display: inline-block;
  height: 22px;
  margin-bottom: 0;
  position: relative;
  text-indent: -5000px;
  width: 35px;

  &:before {
    border-radius: 15px;
    content: '';
    display: block;
    height: 22px;
    left: -2px;
    position: absolute;
    top: -2px;
    transition: 0.25s ease-in-out;
    width: 23px;
  }

  &:after {
    background-color: #fff;
    border: 2px solid #666;
    border-radius: 15px;
    content: '';
    display: block;
    height: 18px;
    left: -2px;
    position: absolute;
    top: -2px;
    transition: 0.25s ease-in-out;
    width: 18px;
  }

  ${Input}:checked + &::before {
    background-color: #666;
    width: 35px;
  }

  ${Input}:checked + &::after {
    left: 13px;
  }

  ${Input}:disabled {
    cursor: not-allowed;
  }
`;

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  margin-bottom: 5px;
`;
